<template>
  <div id="box2">
    <div class="box2">
      <div class="box2-title">什么是会员制在线就业班？</div>
      <div class="box2-one">
        <div class="box2-one-title">课程简介</div>
        <div class="box2-one-txt">
          针对有明确就业需求，但对价格敏感，且自学能力强的用户推出的课程。
        </div>
      </div>
      <div class="box2-two">
        <div class="box2-two-title">核心亮点</div>
        <div class="box2-two-txt">原汁原味的黑马课程体系</div>
        <div class="box2-two-txt">价格更亲民，可阶段性购买</div>
        <div class="box2-two-txt">课程全程解锁，观看更灵活</div>
        <div class="box2-two-txt">享集中答疑/源码开放/课程更新等服务</div>
      </div>
      <div class="button" @click="Open($event)">立抢5折优惠</div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    Open(e){
      this.$store.commit("Openpop",2)
      this.$mai(2,e)
    }
  }
};
</script>

<style lang='scss' scoped>
.box2 {
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 80px;
  width: 690px;
  height: 744px;
  background-color: #6b00d9;
  &-title {
    margin: 0 auto;
    margin-top: 30px;
    width: 476px;
    height: 72px;
    background-color: #45008b;
    border-radius: 10px;
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 72px;
    letter-spacing: 2px;
    color: #ffffff;
    text-align: center;
  }
  &-one {
    overflow: hidden;
    margin: 0 auto;
    margin-top: 30px;
    width: 650px;
    height: 164px;
    background-color: #9f7fff;
    border-radius: 10px 10px 0 0;
    &-title {
      margin-top: 31px;
      padding-left: 41px;
      font-family: SourceHanSansCN-Bold;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 3px;
      color: #fcec4e;
    }
    &-txt {
      width: 551px;
      margin-top: 10px;
      padding-left: 58px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #ffffff;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #ffffff;
        margin-left: -20px;
        position: relative;
        top: -5px;
      }
    }
  }

  &-two {
    overflow: hidden;
    margin: 0 auto;
    width: 650px;
    height: 280px;
    background-image: url('../assets/bgggg.png');
    background-size: cover;
    border-radius: 0 0 10px 10px;
    &-title {
      margin-top: 31px;
      padding-left: 41px;
      font-family: SourceHanSansCN-Bold;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 3px;
      color: #f94b4d;
    }
    &-txt {
      width: 551px;
      margin-top: 10px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #2d2664;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #2d2664;
        margin-left: 38px;
        margin-right: 10px;
        position: relative;
        top: -5px;
      }
    }
  }
  .button {
    margin: 0 auto;
    margin-top: 40px;
    text-align: center;
    width: 560px;
    height: 88px;
    border-radius: 16px;
    background-image: url("../assets/btn.png");
    background-size: cover;

    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 88px;
    letter-spacing: 2px;
    color: #5530fd;
  }
}
</style>